import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doctors-searchadv',
  templateUrl: './doctors-searchadv.component.html',
  styleUrls: ['./doctors-searchadv.component.css']
})
export class DoctorsSearchadvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
